import { useState, useEffect } from 'react';
import { useAuth } from '@/contexts/auth-context';

export const useAdminCheck = () => {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (!user) {
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      try {
        // Check against environment variable for admin user ID
        const adminUserId = import.meta.env.VITE_ADMIN_USER_ID;
        const isUserAdmin = adminUserId && user.id === adminUserId;
        
        setIsAdmin(isUserAdmin);
      } catch (error) {
        console.error('Error checking admin status:', error);
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    };

    checkAdminStatus();
  }, [user]);

  return { isAdmin, loading };
}; 